<template>
    <div>
      <div data-v-60ee706e="" class="loginwindow transitionBody">
        <div data-v-60ee706e="" class="loglines">
          <img data-v-60ee706e="" src="/static/img/wdlogo.png" alt="通胜国际" class="brand-logo">
        </div>
        <div data-v-60ee706e="" class="hero-wrap">
          <img data-v-60ee706e="" src="/static/img/login-hero.png" alt="" class="hero-img">
        </div>
        <div data-v-60ee706e="" class="lginner"><img data-v-60ee706e=""
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAAA6CAMAAAAQoC6jAAAAxlBMVEUAAADR1+fT2OjT2OfT2OXU2ujS1+fU2ejU2ujV2enT2OnU2ujT2OjS1+fS1+fS1+fU2ejR2OjU2OfU2OjV2ejW2ufV2ujU2efV2unT2ejV2OfU2efT2ubT2+nW3Obb2+3U2efV2uj///82Omn8/P3W2+nP1OXS2OdQU3yMj6nN0+WIi6b5+vzv8fff4+7R1ubj5/Dz9Pnt7/bo6/NDR3Ll6PH3+PqQkqzY3euQk6w6P2yanbT19vqRk62WmLBITHalp7ygorj3N9ErAAAAInRSTlMA8vzZE4D2sHtILaOe9+rpycTDuah1bmpnV1U1KSIeDoGd5tYlqQAAAmlJREFUWMO9mOdyIjEMgE0JJRBIb6QQsUhgll22wBEIJe//UsfB5HQ3sSOHku8nw3xjr2wVKyP5cql6nqtnLNRz59VSOa8cyd8UC6FGorYVItRhoXjj4my8FBDbQRJHvmfFj+IkaCMWXhqC7viSNAWxBw54cUCaLo+/8h2RpuEInBkNSdORfXmniAMfvoU/QDy1LPIuq8cRfJtorLN3Jt816QFsxUDTteHzhZjAliQYfvqQVyH2YWv6GF7977snwSca6f5f32NWx7ATsc4+KiYnx0OOTI59RziGnRnj38A8Eb6BgTewYP430pPaUNRDMPCevpp93XRp3nRx43sIyTPd07TV6oKBXqu18E3JgsKHtbBqXiDMWx2Tsbf6eQomhrqyzqdZ8i1bWxsNvpklUVA2vxLeYgDgYGTfL7AQ4O1KeIF9EIySj+/LhVLPJ20PBKOjD7z2ybMq844lI/vsey6rkk5ANDr6INElVcE+yEbBxx+xos4oAgejkw8iOlM58kE2TqbTiewDn3KqxkG2GyedNO1M2GcPc11lHIQwTTuddAoOwoybcO4udNpyb7PlrsuW5aCs4zt5/xOUrkNQhGPD54/Po3BsVgdb9r3yeZQONl89wcdG4eqVMXDxsVFIDpy+BB8bhfTFCVb0sdGeYLkECD7ByCWAi5Tgk4xcpFTFUkZnm/pmMs5tZVQq9DNj7hEKvbUVWS7mYGS2WJoXWBSapZF1mhCapX21c819N5x7b4n33bQfdqzYffA57Gi2+/B44PGWaW4zgDd/5ImAaVQ/HjFGnpXRxyNGtfEDzyz2h6BaxkLti4eg38yjFL29qJTDAAAAAElFTkSuQmCC"
                alt="" class="gbline" @click="back">
            <div data-v-60ee706e="" class="LoginSquare">
                <div data-v-60ee706e="" class="inputline">
                    <img data-v-24d6c286="" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAABACAMAAABiFaQOAAAAflBMVEUAAACgqsqirMqjq8ujrcqirMqirMqirMqirMuirMuircuirMqirMqhrcqirMqjrMujrMuhrsqmq8+irMuirMmirMqirMqirMuirMqirMqirMqjrcyhrMudqsuirMqirMuircmirMqjrMqjrMqjq8qirMqircuirMmhrMmirMq8gjJ1AAAAKXRSTlMAB/okl/frVPDSnObIHfONWyEOiCnNu3FNwYMyLhPe18NqZEJ5sqs0pnkBf7cAAAIhSURBVEjH5ZbdcrIwEIY3IUAA+UcFRa3Wtl/u/wa/7spkWslKnJ50ps+JMxveZLN/EVw0lVpFUkYrVTXgR5CGxhKmgYdEtNJ8Q7Zi8ZjEzEgWDttnhthcxkbkvYoMku0fnnP76G20zm4LNEQPzhLkW1F9tdVr8pC/V0m73vkiNmhtWecwbnqcnY9nSc7BFLeMHZth3lK3psG1N9fKDrPsro0Kvcid2+nPpYr17h/jOOvfim7kJP5cWjlXMLG1W1RjKpwrGHDBZB0j8QORw73OLerQPTYQZ7fozAYipRV2P8XG1bw6u8yw2WiwddauUAzYMMyIUUwPnNGu+NZw1dgrmsMaGFoUyfhOUzAO2HYj1fWr7SKNvSrjYGaQYW8NGzJkD4dYZ0dYJ0RdoQQ1Ha+Yhs+Mdb04lnf3Y3knYJlaaWPRqgY/RKyGTOtsULGAP0hwVsNRmxn6OKiLsyYO15N5yOl6mKW0MIsU39P8cTReHD/AEodTYabVeHB4PlbpVMhhDxO9JMMLGlj6F4PI6aPg9hbHsEAc0cVuYaQtkhwWyRNyiDYgTQMeHEgVT9NTB57p17cp3KF4C55s8euAfjLvrhERHfFujCnBF/p/8g4JTX1veowa4NVyf1GOYeMfTf4hlYDhAH/o+98uks9HL4QT9zTyT+wJyudrr4SO2jbNvXxLqXk7rKYnKe2/YX82giqjlP4SWaIGCdok9FGESUst/h9eYYKZq/SKAAAAAABJRU5ErkJggg==" alt="" class="iconImg">
                    <input v-model="name" data-v-60ee706e="" type="text" maxlength="16"
                        placeholder="请输入手机号或用户名">
                </div>
                <div data-v-60ee706e="" class="inputline">
                    <img data-v-24d6c286="" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAABACAMAAABiFaQOAAAAeFBMVEUAAACircuirMqirMqirMugrdSirMqirMqircqirMuirMqirMqirMqiq8qjq8yhrMmjrMqirMqjrMujrMuhrMujqciirMqirMuhrMqjrMqhrcqirMqircqirMuiq8qirsekq8uircuirMqjrMqkqsiiq8qirMmirMqHIdmMAAAAJ3RSTlMA7vnnrAfk4KRK9NrTNyMcjndyUjEQyFlFwpyLg088KRbMl18qumhiOISfAAABdklEQVRIx+2Wy46DMAxFTSBQ3pRH6fs94///w4mjqqNWDnVmMxvOhsXVUX1jBQos62YTKhVumjUI0W2CT5JWS5xjji/kx89Oq/AN1X5ydkhk20OtdZ1eAyR2084Sievw7LfM0LCcctY0W/hS4kQV1cQpDjEixhW8cCYrHpxSQ3V6eKOiYo3LqWk45qhGGrB2SHsTFlywMsHeIVGjkQsOJkh4pzRRoNkoNFHp3NEWWLbOXUUmufHSzUQRmxQm6XmpZ4+IoHWceelMddmEtgQOaFN8MC3hLPFZFyUZClBJ1D2Ue4EeXKrHxfQiIOuCFhV8RKFlZfogEd1BQLW33gEW9GhASEldFpDYqyLm2958+sFaLg1U37nSqTXP0izNkkRKQ2QI00mJHM76m+Q/Xpz+6+lpX4m+MaWflEFu/6OKOSFibt/lwSB19Ma+y1O0DyELNJgFrKxVi2b7enyfoFfoherJ75SX04GlLORO8bueMYolRhyNQPwA02SGxD6de5oAAAAASUVORK5CYII=" alt="" class="iconImg">
                    <input v-model="password" data-v-60ee706e="" maxlength="16" placeholder="请输入密码"
                    :type="show1?'text':'password'">
                        <img
                        @click="show1=!show1"
                        v-if="!show1"
                        data-v-65d98e59=""
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAAgCAMAAACVQ462AAAAjVBMVEUAAAAeI0guLkkdJUgdJUgdJUgdJEgdJUccJUgfI0kcJUgdJUgdJUgYJEccJUgdJEgcJEcdJEccJEgdJEkcI0cdJUgcJUccJEgcJEgdJUccJEkbJEgdJUcdJUgcJUgdJEgdJUgdJUgdJUgdJUgcJUcdJEccJUcdJUgdJUghIU4dJUgcJUgdJkcfJUsdJUjDjfUdAAAALnRSTlMAGAX65WRVyLEQ4HL3C+vSwKhcMSD0t35rRD8479vXy8OjnIN3SiysiQeWUTwp1k+5hAAAAZdJREFUSMedlNmWgjAMQMPSgoCIgMqmgOI2av7/8+agbSnLDOB9UQK3aUMCqCdrY5UXmM3dL/OCANywxknn+qH1Fm1w8Y21mOer+cfTIcMPJszih2kb8Q9vc/yIWyUsLWRU032fO7oC8NSQcZrqE6Gc60sbOcf7JP+EnZSlCBjhuK5sETuFV5vQxlbHju826ZY8uPRQcKD/6bGBglxqneUWG/a2MmwvSI4NRav1diijeXbQPcqLmA7KVPLSJvZwVtdbRM9xHFOyOxYZ9liLEgQWfsWBzTBx8Es2PmtrETCmaCsp4QMA9GZLLzgbozqFYC+3UtgpSnLV/rY1M24XPQNI+b1IvJNIH9b1pkEqniWEgH2RUqmtMhzElXojYUkUgFX9u5WbjzBhm1BKCKVJwQK+PFPv9vcAIPQ0vQKZlRh2BuXTAxLqzkVzsOkTPhPNs7woAUxhzZ62+6NynOIrrMDOYjA2SpNtZFcdRs77FHUZJRUVH3wzl8kL+O0wmbyAesAaT22H7wbb1zih6VrrRz9Or7q77jfOLwi5kdPVEhAyAAAAAElFTkSuQmCC"
                        class="eye"
                        />
                        <img v-else @click="show1=!show1" data-v-65d98e59="" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAAoCAMAAAB5EAzbAAAAn1BMVEUAAAAdJUgqKkkdJUcdJUgdJEcYKUQdJUgcJUgeJEgdIUceIE0cJUgcJUgdJUgdJUccJEgdJUgdJUgcJUgdJEgdJUgcJUgdJEgcJUgdJUgdJEgbI0gdJUkcJUceJUkfI0kdHU0dJUgdJEgcJUgdJUgdJEccJEgcJUkcIkYcJUgcJUccJUgcJEkdJUgcJUgdJEgdJkkfJ0YgKEgcJUgdJUiVJwGxAAAANHRSTlMA+Abv3EkM69AzHhC+drCphmbk4MO6a5OKcU9APi0oGAjyyqylm1s4JLWhj4Bf19TMISBSdyDvIwAAAe9JREFUSMellOmyojAQhU9YBRQRccf1uutdp9//2cZhklRCUJT7/aHqpOnkdHc1DMLYT9/2hmy9x+k6DlGL9UH/2Kx02WsVcgu1BPSfni4PuRw8l8C8y+HyAnXI0JkqukZaA+OxsSoOpLF6PJsHKxVfcMlf4QlGPHpsSkn1lfkcKkcebXtCidZUwEKozGdFhGsTDZZQiMuGJ1zoQuEnu1maAZ5fmHMrSu5cdt0bu0ufCwclaFqUKrVwqLD3STpmD62LnItAHGchNzzM6A6bCbf6vRFSBK/4ShvBmdEDWPfAn89dAmiTJAlOVEs7H5FkBGDhUGOcsDD9Rg3ZemL87/j2nVaWfTn96mPWgyQo27DjibuwIFjmvV055EOb33f1KE0CVHDsaDmG9/4fTHGXXC3XBJKeMm0zPGSudL0jxD9SYh3UsrdJwKt4YLKtczxBuCGBW1Q4lTMWmUs+DGGKsWzWUR3lk7Gv3AG72TrNjAxd4nxZmMj7Leh4suRbI/VWHF0hlsVnVL4mU1prvEG828eau/lBiYQUjO5Eff4fzlQwNSKYNtoWSgRrvrq9LSPWds12k4YZsOwM0v61SByhgjFpdPAqO9IY41WS375gSho5XmXlk0IfrzMkhT0acFa3dyOuTG6JhhzHLdtuJd94wF9aYcKHBwtsvgAAAABJRU5ErkJggg==" class="eye">
                </div>

                <div data-v-60ee706e="" class="inputline">
                    <img data-v-24d6c286="" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAABACAMAAABiFaQOAAAAeFBMVEUAAACircuirMqirMqirMugrdSirMqirMqircqirMuirMqirMqirMqiq8qjq8yhrMmjrMqirMqjrMujrMuhrMujqciirMqirMuhrMqjrMqhrcqirMqircqirMuiq8qirsekq8uircuirMqjrMqkqsiiq8qirMmirMqHIdmMAAAAJ3RSTlMA7vnnrAfk4KRK9NrTNyMcjndyUjEQyFlFwpyLg088KRbMl18qumhiOISfAAABdklEQVRIx+2Wy46DMAxFTSBQ3pRH6fs94///w4mjqqNWDnVmMxvOhsXVUX1jBQos62YTKhVumjUI0W2CT5JWS5xjji/kx89Oq/AN1X5ydkhk20OtdZ1eAyR2084Sievw7LfM0LCcctY0W/hS4kQV1cQpDjEixhW8cCYrHpxSQ3V6eKOiYo3LqWk45qhGGrB2SHsTFlywMsHeIVGjkQsOJkh4pzRRoNkoNFHp3NEWWLbOXUUmufHSzUQRmxQm6XmpZ4+IoHWceelMddmEtgQOaFN8MC3hLPFZFyUZClBJ1D2Ue4EeXKrHxfQiIOuCFhV8RKFlZfogEd1BQLW33gEW9GhASEldFpDYqyLm2958+sFaLg1U37nSqTXP0izNkkRKQ2QI00mJHM76m+Q/Xpz+6+lpX4m+MaWflEFu/6OKOSFibt/lwSB19Ma+y1O0DyELNJgFrKxVi2b7enyfoFfoherJ75SX04GlLORO8bueMYolRhyNQPwA02SGxD6de5oAAAAASUVORK5CYII=" alt="" class="iconImg">
                    <input v-model="confirmPass" data-v-60ee706e="" maxlength="16" placeholder="请输入确认密码"
                    :type="show2?'text':'password'">
                        <img
                        @click="show2=!show2"
                        v-if="!show2"
                        data-v-65d98e59=""
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAAgCAMAAACVQ462AAAAjVBMVEUAAAAeI0guLkkdJUgdJUgdJUgdJEgdJUccJUgfI0kcJUgdJUgdJUgYJEccJUgdJEgcJEcdJEccJEgdJEkcI0cdJUgcJUccJEgcJEgdJUccJEkbJEgdJUcdJUgcJUgdJEgdJUgdJUgdJUgdJUgcJUcdJEccJUcdJUgdJUghIU4dJUgcJUgdJkcfJUsdJUjDjfUdAAAALnRSTlMAGAX65WRVyLEQ4HL3C+vSwKhcMSD0t35rRD8479vXy8OjnIN3SiysiQeWUTwp1k+5hAAAAZdJREFUSMedlNmWgjAMQMPSgoCIgMqmgOI2av7/8+agbSnLDOB9UQK3aUMCqCdrY5UXmM3dL/OCANywxknn+qH1Fm1w8Y21mOer+cfTIcMPJszih2kb8Q9vc/yIWyUsLWRU032fO7oC8NSQcZrqE6Gc60sbOcf7JP+EnZSlCBjhuK5sETuFV5vQxlbHju826ZY8uPRQcKD/6bGBglxqneUWG/a2MmwvSI4NRav1diijeXbQPcqLmA7KVPLSJvZwVtdbRM9xHFOyOxYZ9liLEgQWfsWBzTBx8Es2PmtrETCmaCsp4QMA9GZLLzgbozqFYC+3UtgpSnLV/rY1M24XPQNI+b1IvJNIH9b1pkEqniWEgH2RUqmtMhzElXojYUkUgFX9u5WbjzBhm1BKCKVJwQK+PFPv9vcAIPQ0vQKZlRh2BuXTAxLqzkVzsOkTPhPNs7woAUxhzZ62+6NynOIrrMDOYjA2SpNtZFcdRs77FHUZJRUVH3wzl8kL+O0wmbyAesAaT22H7wbb1zih6VrrRz9Or7q77jfOLwi5kdPVEhAyAAAAAElFTkSuQmCC"
                        class="eye"
                        />
                        <img v-else @click="show2=!show2" data-v-65d98e59="" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAAoCAMAAAB5EAzbAAAAn1BMVEUAAAAdJUgqKkkdJUcdJUgdJEcYKUQdJUgcJUgeJEgdIUceIE0cJUgcJUgdJUgdJUccJEgdJUgdJUgcJUgdJEgdJUgcJUgdJEgcJUgdJUgdJEgbI0gdJUkcJUceJUkfI0kdHU0dJUgdJEgcJUgdJUgdJEccJEgcJUkcIkYcJUgcJUccJUgcJEkdJUgcJUgdJEgdJkkfJ0YgKEgcJUgdJUiVJwGxAAAANHRSTlMA+Abv3EkM69AzHhC+drCphmbk4MO6a5OKcU9APi0oGAjyyqylm1s4JLWhj4Bf19TMISBSdyDvIwAAAe9JREFUSMellOmyojAQhU9YBRQRccf1uutdp9//2cZhklRCUJT7/aHqpOnkdHc1DMLYT9/2hmy9x+k6DlGL9UH/2Kx02WsVcgu1BPSfni4PuRw8l8C8y+HyAnXI0JkqukZaA+OxsSoOpLF6PJsHKxVfcMlf4QlGPHpsSkn1lfkcKkcebXtCidZUwEKozGdFhGsTDZZQiMuGJ1zoQuEnu1maAZ5fmHMrSu5cdt0bu0ufCwclaFqUKrVwqLD3STpmD62LnItAHGchNzzM6A6bCbf6vRFSBK/4ShvBmdEDWPfAn89dAmiTJAlOVEs7H5FkBGDhUGOcsDD9Rg3ZemL87/j2nVaWfTn96mPWgyQo27DjibuwIFjmvV055EOb33f1KE0CVHDsaDmG9/4fTHGXXC3XBJKeMm0zPGSudL0jxD9SYh3UsrdJwKt4YLKtczxBuCGBW1Q4lTMWmUs+DGGKsWzWUR3lk7Gv3AG72TrNjAxd4nxZmMj7Leh4suRbI/VWHF0hlsVnVL4mU1prvEG828eau/lBiYQUjO5Eff4fzlQwNSKYNtoWSgRrvrq9LSPWds12k4YZsOwM0v61SByhgjFpdPAqO9IY41WS375gSho5XmXlk0IfrzMkhT0acFa3dyOuTG6JhhzHLdtuJd94wF9aYcKHBwtsvgAAAABJRU5ErkJggg==" class="eye">
                </div>

                <div data-v-60ee706e="" class="inputline">
                    <img data-v-24d6c286="" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAABACAMAAABiFaQOAAAAflBMVEUAAACgqsqirMqjq8ujrcqirMqirMqirMqirMuirMuircuirMqirMqhrcqirMqjrMujrMuhrsqmq8+irMuirMmirMqirMqirMuirMqirMqirMqjrcyhrMudqsuirMqirMuircmirMqjrMqjrMqjq8qirMqircuirMmhrMmirMq8gjJ1AAAAKXRSTlMAB/okl/frVPDSnObIHfONWyEOiCnNu3FNwYMyLhPe18NqZEJ5sqs0pnkBf7cAAAIhSURBVEjH5ZbdcrIwEIY3IUAA+UcFRa3Wtl/u/wa/7spkWslKnJ50ps+JMxveZLN/EVw0lVpFUkYrVTXgR5CGxhKmgYdEtNJ8Q7Zi8ZjEzEgWDttnhthcxkbkvYoMku0fnnP76G20zm4LNEQPzhLkW1F9tdVr8pC/V0m73vkiNmhtWecwbnqcnY9nSc7BFLeMHZth3lK3psG1N9fKDrPsro0Kvcid2+nPpYr17h/jOOvfim7kJP5cWjlXMLG1W1RjKpwrGHDBZB0j8QORw73OLerQPTYQZ7fozAYipRV2P8XG1bw6u8yw2WiwddauUAzYMMyIUUwPnNGu+NZw1dgrmsMaGFoUyfhOUzAO2HYj1fWr7SKNvSrjYGaQYW8NGzJkD4dYZ0dYJ0RdoQQ1Ha+Yhs+Mdb04lnf3Y3knYJlaaWPRqgY/RKyGTOtsULGAP0hwVsNRmxn6OKiLsyYO15N5yOl6mKW0MIsU39P8cTReHD/AEodTYabVeHB4PlbpVMhhDxO9JMMLGlj6F4PI6aPg9hbHsEAc0cVuYaQtkhwWyRNyiDYgTQMeHEgVT9NTB57p17cp3KF4C55s8euAfjLvrhERHfFujCnBF/p/8g4JTX1veowa4NVyf1GOYeMfTf4hlYDhAH/o+98uks9HL4QT9zTyT+wJyudrr4SO2jbNvXxLqXk7rKYnKe2/YX82giqjlP4SWaIGCdok9FGESUst/h9eYYKZq/SKAAAAAABJRU5ErkJggg==" alt="" class="iconImg">
                    <input v-model="pid" data-v-60ee706e="" type="text" maxlength="16"
                        placeholder="推荐人(UID)">
                </div>

                <div data-v-60ee706e="" class="inputline">
                    <img data-v-24d6c286="" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA4CAMAAACFZCuiAAAAeFBMVEUAAACirMqircqpsM+irMqfq8yirMqjrMmirMqircuirMugrcqerc+ircuirMqircqkpsWirMqirMqhrMqircyirMqjrMuiq8qjrMujrMqirMqirMqjrcqirMqirMuiq8uirMqircqirMqircuhq8qirsuhq8qirMokTUV0AAAAJ3RSTlMA8cQF0hbaG/twah8K7clEEPWpPiTkuTjAooeBZbCOe1GbdF1LLOUfsCN4AAABo0lEQVRIx+2W2Y7CMAxF3SZpuu8UStk3//8fTp1GMN3zMC8jcR6i1PRAbCHdwIAg8U65zV9RhphFL27nJy+RMEuYNFWEk0RVk4RjQ3o7Fxdxd7eydybPRiP4OdBK8tuw4uv5XjxlygBYKp/F/XyNLfywS8jx3s+b3H/CJOX96ryPeQAo9N72ymlh1IO7hWNnSDBAdt4RaMgPMOZCfQOpYI56/yv9qYQT/HdJ06t/pa+0IlntIswl0ZYz4O1amEsFxQDU7dqYS+e2XMOhXR1ziXLgAIKy7GEqPSgABKgE4MxMYjSBHAC29PHNTNpTdUu7Y5c5BhSu+iEisGgWYt0RG8oZnboHbInDNSeMUY1Ok6sEDlecHb1VD77DTpec1B6eR6js5sFCTDs46lyqWlTMOUmkHDmYDFdp37AphTWuOokYnblCIi7HThkjUU30zE5IWD4M8DMkTmz6jmAhwXv/ji1XxegCM5T6IlO/G5Z1V6kkzHPLujPuU9XnXj96sEhZodaE2FvdPg/Wbz8O9nASMID5m4+y8Wlo5ppWzAl9O7PsOeUHuw13fsFJlQoAAAAASUVORK5CYII=" alt="" class="iconImg">
                    <input v-model="code" data-v-60ee706e="" type="text" maxlength="16"
                        placeholder="请输入验证码">
                    <div data-v-60ee706e="">
                        <img style="cursor: pointer" :src="`/static/image/yzm/${imgLis[index]}.png`" @click="changIndex" alt="获取验证码..." class="yzm" />
                    </div>
                </div>

                <div data-v-60ee706e="" id="captcha" style="position: relative; top: 10px;"></div>
             


                <div data-v-24d6c286="" class="sumbtns" :class="{sbac:isOk}"><button @click="register" data-v-24d6c286="" type="submit" class="van-button van-button--info van-button--normal van-button--block"><div data-v-24d6c286="" class="van-button__content"><span data-v-24d6c286="" class="van-button__text"> 注册 </span></div></button></div>

                <div @click="back()" data-v-24d6c286="" class="botline"><div data-v-24d6c286="">返回登录</div></div>

            </div>
        </div>
    </div>
    </div>
  </template>
  <script>
  export default {
    name: 'login',
    data() {
      return {
        show1:false,
        show2:false,
        auto:false,
        registerInfo: {},
        loginInfo: {},
        imgLis: ['2PYL', '6AQ5', '8PHD', '21I7', '69HM', 'ACWA', 'DUZ7', 'IY98', 'K647', 'M52T', 'NY52', 'NZFA', 'SN76', 'SP4D', 'VAEO', 'YFQM', 'ZZU5', '7GQT', 'LFW3', 'NU2T', 'UAE3'],
        index: 0,
        infoType: 0, //0 是登陆 1是注册
        psw1: true,
        psw2: true,
        psw3: true,
        pid: '',
        name:'',
        password:'',
        confirmPass:'',
        isOk:false,
        code:''
      };
    },
    created() {
      let that = this;
      var query = that.$route.query;
      if (query.type) {
        that.infoType = query.type;
      }
      if (query.pid) {
        that.pid = query.pid;
      }
      that.changIndex();
    },
    watch:{
      name(){
        this.get_test()
      },
      password(){
        this.get_test()
      },
      confirmPass(){
        this.get_test()
      },
      code(){
        this.get_test()
      },
    },
    methods: {
      get_test(){
        if(this.name&&this.password&&this.confirmPass&&this.code){
          this.isOk=true
        }else{
          this.isOk=false
        }
      },
      back(){
        window.history.go(-1)
      },
      go(s){
        this.$router.push(s)
      },
      changPsw(name) {
        this[name] = !this[name];
      },
      changInfoType(type) {
        if(type==1){
          this.$router.push('reg')
          return
        }
        let that = this;
        if (that.infoType == type) {
          return;
        }
        that.infoType = type;
        that.changIndex();
        that.loginInfo = {};
        that.registerInfo = {};
        this.psw1 = true;
        this.psw2 = true;
        this.psw3 = true;
      },
      changIndex() {
        this.index = parseInt(20 * Math.random());
      },
      register() {
        let that = this;
  
        var info = {
            realname: this.name,
            name: this.name,
            password: this.password,
            confirmPass: this.confirmPass,
            code: this.code,
            paypassword:123456
        };
        // info = {
        //     realname: "游客试玩",
        //     name: "游客试玩123456",
        //     password: 123456,
        //     confirmPass: 123456,
        //     code: this.code,
        //     paypassword:123456
        // }
        console.log(info);
        if (!info.name || info.name.length < 6) {
          that.$parent.showTost(0, ' 用户名长度6~16位，以字母或数字组合！');
          return;
        }
        if (!info.password || info.password.length < 6) {
          that.$parent.showTost(0, '请输入正确的密码长度，最少6位！');
          return;
        }
        if (!info.confirmPass || info.confirmPass != info.password) {
          that.$parent.showTost(0, '两次密码不一致！');
          return;
        }
        // if (!info.realname || info.realname.length < 2) {
        //   that.$parent.showTost(0, '请输入您的真实姓名!');
        //   return;
        // }
  
        // if (!info.paypassword || info.paypassword.length < 6) {
        //   that.$parent.showTost(0, '请输入正确的支付密码长度，最少6位！');
        //   return;
        // }
        let code = this.code;
        if (!this.code) {
          that.$parent.showTost(0, '请输入验证码！');
  
          return;
        }
        if (code.toUpperCase() != that.imgLis[that.index]) {
          that.$parent.showTost(0, '验证码错误！');
          that.code = '';
          that.changIndex();
          return;
        }
        that.$parent.showLoading();
        if (that.pid) {
          info.pid = that.pid;
        }
        console.log(info);
        that.$apiFun.register(info).then(res => {
          that.$parent.showTost(1, res.message);
          if (res.code == 200) {
            // sessionStorage.setItem('token', res.data.api_token);
            // that.$store.commit('changToken');
            // that.$parent.getUserInfo();
            // that.$parent.openDaoTime();
  
            that.back();
          }
          that.$parent.hideLoading();
        });
      },
      login() {
        let that = this;
        let info = {
          name:this.name,
          password:this.password
        };
        if (!info.name || !info.password) {
          // that.$parent.showTost(0, '请输入您的账号和密码！');
          return;
        }
        // let code = that.loginInfo.code;
        // if (!code) {
        //   that.$parent.showTost(0, '请输入验证码！');
  
        //   return;
        // }
        // if (code.toUpperCase() != that.imgLis[that.index]) {
        //   that.$parent.showTost(0, '验证码错误！');
        //   that.loginInfo.code = null;
        //   that.changIndex();
        //   return;
        // }
  
        that.$parent.showLoading();
        that.$apiFun.login(info).then(res => {
          if (res.code !== 200) {
            that.$parent.showTost(0, res.message);
            that.$parent.hideLoading();
          }
          if (res.code === 200) {
            sessionStorage.setItem('token', res.data.api_token);
            localStorage.setItem('token', res.data.api_token);
            that.$store.commit('changToken');
            that.$parent.getUserInfo();
            that.$parent.openDaoTime();
  
            that.$parent.goNav('/');
          }
          that.$parent.hideLoading();
        });
      },
    },
    mounted() {
      let that = this;
    },
    updated() {
      let that = this;
    },
    beforeDestroy() {},
  };
  </script>
  <style lang="scss" scoped>
  // .login {
  //   background: url(/static/img/bgimg.c7a960a1.jpg) no-repeat;
  //   width: 100%;
  //   height: 100%;
  //   position: fixed;
  //   background-size: 100% 100%;
  // }
  
  .loginwindow[data-v-60ee706e] {
    width:100%;
    min-height:100vh;
    height:auto;
    background-color:#fff;
    background-image:none;
    overflow-y:auto;
    -webkit-overflow-scrolling:touch;
  }
  .loginwindow .loglines[data-v-60ee706e] {
    display:-webkit-box;
    display:-webkit-flex;
    display:-ms-flexbox;
    display:flex;
    -webkit-box-pack:center;
    -webkit-justify-content:center;
    -ms-flex-pack:center;
    justify-content:center;
    -webkit-box-align:center;
    -webkit-align-items:center;
    -ms-flex-align:center;
    align-items:center;
    width:100%;
    height:auto;
    margin-top:0;
    margin-bottom:0;
    padding:0.32rem 0 0.08rem;
    position:relative;
  }
  .loginwindow .loglines img[data-v-60ee706e],
  .loginwindow .loglines .brand-logo[data-v-60ee706e] {
    width:4.4rem;
    max-width:80%;
  }
  .hero-wrap[data-v-60ee706e] {
    width:100%;
    line-height:0;
  }
  .hero-wrap .hero-img[data-v-60ee706e] {
    width:100%;
    height:auto;
    display:block;
    object-fit:contain;
    object-position:center top;
  }
  .loginwindow .lginner[data-v-60ee706e] {
    float: none;
    width: calc(100% - 0.8rem);
    max-width: 9.2rem;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 0.56rem 1.06667rem 0.8rem;
    height: auto;
    z-index: 200;
    border: .02667rem solid #fff;
    background-color: #f0f4fa;
    border-radius: .53333rem;
    margin: 0.24rem auto 0.8rem;
    left: auto;
    right: auto;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    padding-top: 0.56rem;
    padding-bottom: 0.8rem;
    transform: none;
  }
  .loginwindow .LoginSquare {
    width: 100%;
  }
  .loginwindow .lginner .gbline[data-v-60ee706e] {
    position:fixed;
    right:.26667rem;
    top:.26667rem;
    width:1.06667rem
  }
  .loginwindow .LoginSquare .inputline[data-v-60ee706e] {
    width:100%;
    height:1.2rem;
    background-color:#fff;
    border-radius:.26667rem;
    box-sizing:border-box;
    margin-top:.26667rem;
    position:relative;
    display: flex;
    align-items: center;
  }
  .loginwindow .LoginSquare .inputline input[data-v-60ee706e] {
    width:6.66667rem;
    // height:100%;
    padding-left:.4rem;
    color:#1d2548;
    text-align:left;
    line-height:1.12rem;
    font-size:.37333rem;
    border:none;
    outline:none;
    z-index:2;
    border-radius:.26667rem;
    background-color:#fff
  }
  .loginwindow .LoginSquare .inputline div[data-v-60ee706e] {
    width:50%;
    height:1.2rem;
    position:absolute;
    z-index:10;
    right:0;
    border-radius:.26667rem
  }
  .loginwindow .LoginSquare .inputline .eye{
    width:.42667rem;
    height:.21333rem;
    margin-right:.4rem;
    z-index:3;
    position: relative;
    z-index: 10;
  }
  .loginwindow .LoginSquare .inputline .yzm[data-v-60ee706e] {
    width:1.89333rem;
    height:.66667rem;
    border:.02667rem solid #e3e4ea;
    float:right;
    margin-top:.21333rem;
    margin-right:.4rem;
    right:0;
    position:absolute;
    z-index:3
  }
  .loginwindow .LoginSquare .confirm[data-v-60ee706e] {
    display:-webkit-box;
    display:-webkit-flex;
    display:-ms-flexbox;
    display:flex;
    -webkit-box-pack:center;
    -webkit-justify-content:center;
    -ms-flex-pack:center;
    justify-content:center
  }
  .loginwindow .LoginSquare .confirm .sumbtns[data-v-60ee706e] {
    height:1.2rem;
    color:#fff;
    width:5.33333rem;
    background-color:#237bff;
    border-radius:.21333rem;
    margin-top:.8rem;
    font-size:.45333rem;
    font-weight:700;
    opacity:.7;
    text-align: center;
    line-height: 1.2rem;
  }
  .loginwindow .LoginSquare .confirm .sbac[data-v-60ee706e] {
    opacity:1
  }
  .loginwindow .LoginSquare .botline[data-v-60ee706e] {
    float:left;
    width:100%;
    height:.37333rem;
    display:-webkit-box;
    display:-webkit-flex;
    display:-ms-flexbox;
    display:flex;
    margin-top:.53333rem
  }
  .loginwindow .LoginSquare .botline div[data-v-60ee706e] {
    flex:1;
    color:#0b1028;
    font-size:.37333rem;
    text-align: center;
  }
  .loginwindow .LoginSquare .botline div[data-v-60ee706e]:first-child {
    margin-left:.8rem
  }
  .loginwindow .LoginSquare .botline div[data-v-60ee706e]:nth-child(2) {
    margin-right:.8rem
  }
  .loginwindow .LoginSquare .oplines[data-v-60ee706e] {
    display:-webkit-box;
    display:-webkit-flex;
    display:-ms-flexbox;
    display:flex;
    -webkit-box-pack:justify;
    -webkit-justify-content:space-between;
    -ms-flex-pack:justify;
    justify-content:space-between;
    width:100%;
    padding-top:.77333rem;
    color:#1d2548;
    font-size:.4rem;
    font-family:PingFang SC;
    font-weight:500
  }
  .loginwindow .LoginSquare .oplines>div .van-checkbox__icon[data-v-60ee706e] {
    font-size:.34667rem;
    height:.34667rem;
    line-height:.34667rem
  }
  .loginwindow .LoginSquare .oplines>div .van-icon[data-v-60ee706e] {
    width:.34667rem;
    height:.34667rem;
    border-radius:.08rem
  }
  .loginwindow .LoginSquare .oplines>div .van-checkbox__label[data-v-60ee706e] {
    height:.34667rem;
    line-height:.34667rem
  }
  .loginwindow .LoginSquare .oplines>div .van-checkbox__icon--checked .van-icon[data-v-60ee706e] {
    background-color:#1989fa
  }
  .loginwindow .LoginSquare .oplines .ltbox[data-v-60ee706e] {
    display:-webkit-box;
    display:-webkit-flex;
    display:-ms-flexbox;
    display:flex;
    -webkit-box-align:center;
    -webkit-align-items:center;
    -ms-flex-align:center;
    align-items:center
  }
  .loginwindow .LoginSquare .oplines .ltbox>img[data-v-60ee706e] {
    margin-right:.08rem;
    width:.85333rem;
    height:.48rem
  }

  
  .sumbtns {
    height: 1.2rem;
    color: #fff;
    margin-top: .8rem;
    font-size: .45333rem;
    font-weight: 700;
    opacity: .7;
    width: 100%;
    background-color: #237bff;
    border-radius: .21333rem;
}
.botline {
    width: 100%;
    height: .37333rem;
    display: flex;
    margin-top: .53333rem;
    justify-content: center;
}
.sumbtns .van-button--block {
    width: 100%;
    height: 100%;
    background-color: #a134f1;
    border-radius: .21333rem;
    border: 0;
}

.iconImg {
    width: .34667rem;
    height: .42667rem;
    margin-left: .4rem;
    z-index: 3;
    left: 0;
}

.yzm {
    width: 1.89333rem;
    height: auto;
    margin-top: .21333rem;
    margin-right: .4rem;
    right: 0;
    position: absolute;
    z-index: 3;
}

.sbac[data-v-24d6c286] {
    opacity: 1;
}
  </style>
  



// WEBPACK FOOTER //
// src/components/reg2.vue